import {Component, AfterViewInit} from '@angular/core';
import {Http} from "@angular/http";
import {ActivatedRoute} from "@angular/router";
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";

declare var jQuery;
declare var grapesjs;

@Component({
    templateUrl: './grape.component.html',
    styleUrls: [ './grape.component.scss' ]
})
export class GrapeComponent implements AfterViewInit {
    public isLoaded = false;
    public itemId = false;

    constructor(private http: Http, private route: ActivatedRoute) {
    }

    ngAfterViewInit() {

        this.route.params.subscribe(params => {
          this.itemId = params.id;

          this.http.get(environment.backendUrl+'api/template/'+ this.itemId)
                 .subscribe(
                  response => {
                    this.isLoaded = true;
                    console.log(response.json().html, response.json().css);
                    this.initGrape(response.json().html, response.json().css);
                  },
                  error => {
                    // toastr
                  }
                );

        });      
    }

    initGrape(html, css) {
      let self = this;
      let defaultCss = ' ';

        const editor = grapesjs.init({
          clearOnRender: true,
          plugins: ['gjs-preset-newsletter', 'gjs-plugin-ckeditor'],
          pluginsOpts: {
             'gjs-preset-newsletter': {
               inlineCss: false,
               modalLabelImport: 'Paste all your code here below and click import',
               modalLabelExport: 'Copy the code and use it wherever you want',
               codeViewerTheme: 'material',
               //defaultTemplate: templateImport,
               importPlaceholder: '<table class="table"><tr><td class="cell">Hello asd world!</td></tr></table>',
               cellStyle: {
                 'font-size': '12px',
                 'font-weight': 300,
                 'vertical-align': 'top',
                 color: 'rgb(111, 119, 125)',
                 margin: 0,
                 padding: 0,
               }
             },
             'gjs-plugin-ckeditor': {
               position: 'center',
               options: {
                 startupFocus: true,
                 extraAllowedContent: '*(*);*{*}', // Allows any class and any inline style
                 allowedContent: true, // Disable auto-formatting, class removing, etc.
//                 enterMode: CKEDITOR.ENTER_BR,
                 extraPlugins: 'sharedspace,justify,colorbutton,panelbutton,font',
                 toolbar: [
                   { name: 'styles', items: ['Font', 'FontSize' ] },
                   ['Bold', 'Italic', 'Underline', 'Strike'],
                   {name: 'paragraph', items : [ 'NumberedList', 'BulletedList']},
                   {name: 'links', items: ['Link', 'Unlink']},
                   {name: 'colors', items: [ 'TextColor', 'BGColor' ]},
                 ],
               }
             }
          },
          // Indicate where to init the editor. You can also pass an HTMLElement
          container: '#grapeEditor',

          // Get the content for the canvas directly from the element
          // As an alternative we could use: `components: '<h1>Hello World Component!</h1>'`,
          //fromElement: true,
          //components: html,
          style: defaultCss + css,

          // Size of the editor
          height: 'calc(100% - 110px)',
          width: '100%',
          // Disable the storage manager for the moment
          storageManager: { type: null },
          // Avoid any default panel

          deviceManager: {
            devices: [{
                name: 'Desktop',
                width: '', // default size
              }, {
                name: 'Mobile',
                width: '320px', // this value will be used on canvas width
                widthMedia: '480px', // this value will be used in CSS @media
            }]
          } 
        });


        // Let's add in this demo the possibility to test our newsletters
        var mdlClass = 'gjs-mdl-dialog-sm';
        var pnm = editor.Panels;
        var cmdm = editor.Commands;
        var traitManager = editor.TraitManager;


        var pfx = editor.getConfig().stylePrefix;
        var modal = editor.Modal;
        var codeViewer = editor.CodeManager.getViewer('CodeMirror').clone();
        var container = document.createElement('div');
        var btnEdit = document.createElement('button');

        codeViewer.set({
            codeName: 'htmlmixed',
            readOnly: 0,
            theme: 'hopscotch',
            autoBeautify: true,
            autoCloseTags: true,
            autoCloseBrackets: true,
            lineWrapping: true,
            styleActiveLine: true,
            smartIndent: true,
            indentWithTabs: true
        });

        btnEdit.innerHTML = 'Edit';
        btnEdit.className = pfx + 'btn-prim ' + pfx + 'btn-import';
        btnEdit.onclick = function() {
            var code = codeViewer.editor.getValue();
            editor.DomComponents.getWrapper().set('content', '');
            editor.setComponents(code.trim());
            modal.close();
        };

        cmdm.add('html-edit', {
            run: function(editor, sender) {
                sender && sender.set('active', 0);
                var viewer = codeViewer.editor;
                modal.setTitle('Edit code');
                if (!viewer) {
                    var txtarea = document.createElement('textarea');
                    container.appendChild(txtarea);
                    container.appendChild(btnEdit);
                    codeViewer.init(txtarea);
                    viewer = codeViewer.editor;
                }
                var InnerHtml = editor.getHtml();
                var Css = editor.getCss();
                modal.setContent('');
                modal.setContent(container);
                codeViewer.setContent(InnerHtml + "<style>" + Css + '</style>');
                modal.open();
                viewer.refresh();
            }
        });

        pnm.addButton('options',
            [
                {
                    id: 'edit',
                    className: 'fa fa-edit',
                    command: 'html-edit',
                    attributes: {
                        title: 'Edit'
                    }
                }
            ]
        );

        
        // traits
        editor.DomComponents.getType("text").model.prototype.defaults.traits.push(
          {label: "Editable", type: 'checkbox', name: "data-editable"}
        );

        editor.DomComponents.getType("image").model.prototype.defaults.traits.push(
          {label: "Editable", type: 'checkbox', name: "data-uploadable"}
        );

        editor.setComponents(html);



        // Simple warn notifier
        var origWarn = console.warn;
        //toastr.options = {
        //   closeButton: true,
        //   preventDuplicates: true,
        //   showDuration: 250,
        //   hideDuration: 150
        // };
        console.warn = function (msg) {
          //toastr.warning(msg);
          origWarn(msg);
        };

        // Beautify tooltips
        var titles = document.querySelectorAll('*[title]');
        for (var i = 0; i < titles.length; i++) {
          var el = titles[i];
          var title = el.getAttribute('title');
          title = title ? title.trim(): '';
          if(!title)
            break;
          el.setAttribute('data-tooltip', title);
          el.setAttribute('title', '');
        }


        // Do stuff on load
        editor.on('load', function() {
          var $ = grapesjs.$;
          self.isLoaded = true;

        });

        // save
        pnm.addButton('options', {
          id: 'save-db',
          className: 'fa fa-floppy-o',
          command: 'save-db',
          attributes: {
            title: 'Save DB',
            'data-tooltip-pos': 'bottom'
          }
        });

        cmdm.add('save-db', {
            run: (editor, sender) => {
                sender && sender.set('active', 0); // turn off the button
                editor.store();

                var htmldata = editor.getHtml();
                var cssdata = editor.getCss();
                console.log(htmldata);
                console.log(cssdata);

                this.http.put(
                  environment.backendUrl+'api/template/'+ this.itemId,
                  {
                    html: htmldata,
                    css: cssdata,
                    nazwa: 'test'
                  }
                ).subscribe(
                  response => {
                    // toastr
                  },
                  error => {
                    // toastr
                  }
                );
            }
       });
    }
}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/grape/grape.component.ts